package kz.dentalcrm.app.theme

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.graphics.Color

@Immutable
data class ThemeColor(
    val primary: Color,
    val onPrimary: Color,
    val primaryHover: Color,
    val primarySubdued: Color,
    val primarySubduedSecond: Color,
    val surface: Color,
    val surfaceSecondary: Color,
    val onSurface: Color,
    val onSurfaceVariant: Color,
    val surfaceTertiary: Color,
    val surfaceBackground: Color,
    val surfaceInput: Color,
    val surfaceAlternative: Color,
    val surfaceBackgroundSecondary: Color,
    val outline: Color,
    val success: Color,
    val successSubdued: Color,
    val error: Color,
    val errorSubdued: Color,
    val dividerPrimary: Color,
    val defaultRipple: Color,
)

val LightColorScheme = ThemeColor(
    primary = Color(0xFF0EA5E9),
    onPrimary = Color(0xffffffff),
    primaryHover = Color(0xFF38BDF8),
    primarySubdued = Color(0xFFE0F2FE),
    primarySubduedSecond = Color(0xFFCCE3F3),
    surface = Color(0xfff2f7ff),
    surfaceSecondary = Color(0xfffcfdff),
    onSurface = Color(0xFF171717),
    onSurfaceVariant = Color(0XFF737373),
    surfaceInput = Color(0xFFFCFCFC),
    surfaceBackground = Color(0xffffffff),
    surfaceBackgroundSecondary = Color(0xFFF8F8F8),
    surfaceAlternative = Color(0xffebf3ff),
    outline = Color(0xffb8b8b8),
    success = Color(0xFF22C55E),
    successSubdued = Color(0xFFDCFCE7),
    error = Color(0xFFEF4444),
    errorSubdued = Color(0xFFFEE2E2),
    surfaceTertiary = Color(0xFFF2F2F2),
    dividerPrimary = Color(0xFFEAEDED),
    defaultRipple = Color(0x1a0e00d7)
)

val DarkColorScheme = ThemeColor(
    primary = Color(0xff0d97d4),
    onPrimary = Color(0xffffffff),
    primaryHover = Color(0xFF7DD3FC),
    primarySubdued = Color(0xFF0C4A6E),
    primarySubduedSecond = Color(0xFF265B79),
    surface = Color(0xFF171717),
    surfaceSecondary = Color(0xff151515),
    surfaceAlternative = Color(0xFF131313),
    onSurface = Color(0xFFFFFFFF),
    onSurfaceVariant = Color(0xFFA3A3A3),
    surfaceBackground = Color(0xFF232323),
    surfaceBackgroundSecondary = Color(0xFF323232),
    surfaceInput = Color(0xFF111111),
    outline = Color(0xff494949),
    success = Color(0xFF4ADE80),
    successSubdued = Color(0xFF14532D),
    surfaceTertiary = Color(0xFFF2F2F2),
    error = Color(0xFFF87171),
    errorSubdued = Color(0xFF7F1D1D),
    dividerPrimary = Color(0xFFA3A3A3),
    defaultRipple = Color(0x1a0e00d7)
)

val LocalLightColor = staticCompositionLocalOf { LightColorScheme }
val LocalDarkColor = staticCompositionLocalOf { DarkColorScheme }

val LocalThemeColors = staticCompositionLocalOf { LightColorScheme }